import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../shared/components/RouteError";
import { RoutePending } from "../shared/components/RoutePending";

/**
 * @purpose Understand what Belora is and get to sign in
 * @primary Landing hero + sign-in
 * @persona all
 */
export const Route = createFileRoute("/_public/")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
